import { AutoDismissFlag, FlagGroup } from '@atlaskit/flag';
import SuccessIcon from '@atlaskit/icon/glyph/check-circle';
import { token } from '@atlaskit/tokens';

interface Props {
  flags: number[];
  handleDismiss: () => void;
  userName: string;
}

export const KudosModalFlags = ({ flags, handleDismiss, userName }: Props) => {
  return (
    <FlagGroup onDismissed={handleDismiss}>
      {flags.map((flagId) => {
        return (
          <AutoDismissFlag
            id={flagId}
            icon={
              <SuccessIcon
                label="Success"
                primaryColor={token('color.icon.success')}
                size="medium"
              />
            }
            key={flagId}
            title={`Peer recognition sent`}
            description={`Great job! ${userName} received 100 bonus points from your recognition.`}
          />
        );
      })}
    </FlagGroup>
  );
};
